import axios from 'axios'
import store from '@/store'

export const logout = async () => {
  try {
    const logoutUrl = process.env.VUE_APP_SESSION_LOGOUT_URL ? process.env.VUE_APP_SESSION_LOGOUT_URL : '/logout'
    const logoutAxiosInstance = axios.create()

    if (process.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
      const token = store.getters['notifications/token'] ? store.getters['notifications/token'] : ''
      if (token) {
        await logoutAxiosInstance.get(logoutUrl, { params: { token } })
      } else {
        await logoutAxiosInstance.get(logoutUrl)
      }
    } else {
      await logoutAxiosInstance.get(logoutUrl)
    }
  } catch (error) {
    console.log('logout error')
    throw new Error(error)
  }
}

export const login = async ({ username, email, password }) => {
  try {
    const loginUrl = process.env.VUE_APP_SESSION_LOGIN_URL ? process.env.VUE_APP_SESSION_LOGIN_URL : '/login'
    // const customerId = '61dc442d1bfce14854779785'

    let result
    if (process.env?.VUE_APP_SESSION_LOGIN_BY_EMAIL !== 'yes') {
      result = await axios.post(loginUrl, { username, password })
    } else {
      result = await axios.post(loginUrl, { email, password })
    }

    store.commit('session/mutateAuthenticated', {
      accessToken: 'token',
      idToken: '1',
      expiresIn: 2 * 60 * 60
    })
    return result.data
    // localStorage.setItem('currentCustomer', JSON.stringify(customer))
  } catch (error) {
    console.log('login error')
    throw new Error(error)
  }
}

export const getUserInfo = async () => {
  try {
    const response = await axios.get('/users/info')
    const {
      id = null,
      role = '',
      roles = [],
      privileges = [],
      avatar = '',
      profilePicture = '',
      userInitials = '',
      emailWasConfirmed = false,
      plan = {},
      ...extra
    } = response.data
    let userProfile = {
      id,
      role,
      roles,
      privileges,
      avatar,
      profilePicture,
      userInitials,
      emailWasConfirmed,
      plan,
      extra
    }
    return userProfile
  } catch (error) {
    return {
      username: 'Anonimo'
    }
    // throw new Error('GetUserInfo error')
  }
}
